import React from 'react';
import PropTypes from 'prop-types';

const Arrow = ({ color }) => (
  <svg width="24" height="23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      stroke={color}
      strokeWidth="2"
      d="M6.343 5.657l11.314 11.314M17.657 5.657L6.343 16.971"
    />
  </svg>
);

Arrow.propTypes = {
  color: PropTypes.string,
};

Arrow.defaultProps = {
  color: '#233D4F',
};

export default Arrow;
